const updateWorkoutsLoading = (state, { payload: { loading } }) => {
	state.loading = loading;
};

export default updateWorkoutsLoading;
